/* eslint-disable react/prop-types */
import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames';
import Finish from '../components/Finish';
import Navigation from './Navigation';
import Browser from './Browser';
import History from './History';
import Preview from '../components/Browser/Preview';
import ProjectSwitcher from '../components/Navigation/ProjectSwitcher';
import { reset, getConfig, addBuild } from '../actions';
import ProjectPurchase from '../components/Navigation/ProjectPurchase';

/**
 * Root application component
 *
 * @author John Noel <john.noel@joipolloi.com>
 * @package Minifigs
 */
const App = ({ selected, projectTitle, finished, errorOnBuy, showNavigation, showToast, loaded, dispatch, sections }) => {
    const [enableBuilder, setEnableBuilder] = useState(false);
    const [configLoaded, setConfigLoaded] = useState(false);
    let classes = classNames('builder', {
        'builder-shownavigation': showNavigation,
        'builder-showtoast': showToast,
        'builder-finished': finished,
        'builder-hasProjectTitle': enableBuilder,
        'builder-no-projectTitleExists': !enableBuilder,
    });

    useEffect(() => {
        const url = new URL(window.location.href);
        const params = new URLSearchParams(url.search);

        const paramsProjectTitle = params.get('projectTitle');
        const paramsSkintone = params.get('skintone');
        // eslint-disable-next-line no-extra-boolean-cast
        if (!configLoaded) {
            dispatch(getConfig());
            setConfigLoaded(true);
        } else {
            if (paramsProjectTitle && paramsSkintone) {
                dispatch(addBuild({ projectTitle: paramsProjectTitle, skintone: paramsSkintone }));
                setEnableBuilder(true);
                url.search = '';
                window.history.replaceState({}, '', url);
            }
        }
    }, [dispatch, sections, configLoaded]);

    if (!supportsFetch()) {
        return (
            <div>
                <div className="woocommerce-message">
                    Looks like your browser can&apos;t handle our Minifig Builder! Why not try using{' '}
                    <a href="https://getfirefox.com">Firefox</a> or{' '}
                    <a href="https://www.google.com/chrome/">Google Chrome</a>?<br />
                    All figure builder components are also available in the{' '}
                    <a href="https://minifigs.me/product-category/buy-bits/">&apos;Buy Bits&apos;</a> section.
                </div>

                <div style={{ height: '600px' }} />
            </div>
        );
    }

    if (finished && !errorOnBuy) {
        window.location.href = '/cart';

        return (
            <div className={classes}>
                <Finish projectTitle={projectTitle} resetAppState={() => dispatch(reset())} />
            </div>
        );
    }

    return (
        <div className={classes}>
            <Navigation setEnableBuilder={setEnableBuilder} enableBuilder={enableBuilder} />
            <ProjectSwitcher setEnableBuilder={setEnableBuilder} />
            <div className="builder-inner">
                {loaded && <Browser />}
                <Preview selected={selected} />
            </div>
            <ProjectPurchase setEnableBuilder={setEnableBuilder} />
            <History />
        </div>
    );
};

const supportsFetch = () => 'fetch' in window;

const mapStateToProps = (state) => ({
    selected: state.builds[state.currentBuildIndex].selected,
    projectTitle: state.builds[state.currentBuildIndex].projectTitle,
    finished: state.finished,
    errorOnBuy: state.errorOnBuy,
    showNavigation: state.showNavigation,
    showToast: state.showToast,
    loaded: state.loaded,
    sections: state.sections,
});

export default connect(mapStateToProps)(App);
